<template>
    <el-container>
        <el-aside width="25%">
            <h3>{{ $t("posts.edit.contactTitle") }}</h3>
            <p class="text-justify">{{ $t("posts.edit.contactText") }}</p>
        </el-aside>
        <el-container style="width: 100%;">
            <el-main>
                <el-col :span="24">
                    <el-form-item :label="$t('posts.edit.contactFirstnameLastname') + ' *'" prop="contact_a_afficher">
                        <el-select
                                clearable
                                filterable
                                allow-create
                                default-first-option
                                v-model="contactSelected"
                                @change="changeValue('contact')"
                        >
                            <el-option
                                    style="text-transform:capitalize"
                                    v-for="contact in this.contacts"
                                    :key="contact.id"
                                    :value="contact.id"
                                    :label="contact.fullname"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="user.isUSH">
                    <el-form-item :label="$t('posts.edit.commercialEntityCode')">
                        <el-input v-model="post.id_externe_pdv" />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="E-mail *" prop="email_a_afficher">
                        <el-input v-model="post.email_a_afficher" @input="changeValue('email_a_afficher')" :value.sync="valeur"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Telephone *" prop="telephone_a_afficher">
                        <el-input v-model="post.telephone_a_afficher"  @input="changeValue('telephone_a_afficher')" :value.sync="valeur"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Mobile">
                        <el-input v-model="post.telephone_mobile_a_afficher"  @input="changeValue('telephone_mobile_a_afficher')" :value.sync="valeur"/>
                    </el-form-item>
                </el-col>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import { getUsers } from '@/services/users'
import { mapGetters } from 'vuex'

export default {
  name: 'PostFormContactInfoBV',
  props: ['post'],
  data () {
    return {
      contacts: [],
      contactSelected: null,
      value: '',
      chargement: true,
      hasAnnonce: false
    }
  },
  methods: {
    changeValue (elem) {
      if (elem === 'contact') {
        if (this.contactSelected) {
          const contact = this.contacts.find(x => x.id === this.contactSelected)
          if (contact) {
            this.syncContactFieldsFromUser(contact)
          }
        } else {
          this.post.contact_a_afficher = ''
        }
      } else {
        if (this.post[elem] == '') {
          this.value = ''
        } else {
          this.value = this.post[elem]
        }
      }
    },
    controleContactSelectionne () {
      if (!this.contacts.length) {
        return
      }

      const idOnPost = this.post.id_contact_a_afficher
      const idStillValid = idOnPost && this.contacts.some(c => c.id === idOnPost)
      if (idStillValid) {
        this.contactSelected = idOnPost
        return
      }

      const contact = this.findContactFromPost()
      if (contact) {
        this.contactSelected = contact.id
        this.post.id_contact_a_afficher = contact.id
      }
    },
    syncContactFieldsFromUser (contact) {
      if (!contact) {
        return
      }

      this.post.id_contact_a_afficher = contact.id
      this.post.contact_a_afficher = contact.fullname || ''
      this.post.email_a_afficher = contact.email || ''
      this.post.telephone_a_afficher = contact.phone || ''
      this.post.telephone_mobile_a_afficher = contact.mobile || ''
    },
    findContactFromPost () {
      if (!this.contacts.length) {
        return null
      }
      if (this.post.id_contact_a_afficher) {
        const byId = this.contacts.find(c => c.id === this.post.id_contact_a_afficher)
        if (byId) {
          return byId
        }
      }
      if (this.post.contact_a_afficher) {
        return this.contacts.find(c =>
          (c.fullname || '').trim() === this.post.contact_a_afficher.trim()
        ) || null
      }
      return null
    }
  },
  async mounted () {
    const filtresContacts = { active: true, pagination: false }
    if (this.isSubUser) {
      // pour un simple utilisateur, sélection uniquement sur lui même
      filtresContacts.id = this.user.id
    }
    this.contacts = (await getUsers(filtresContacts)).list
    if (this.isSubUser) {
      const contact = this.contacts[0]
      this.contactSelected = contact.id
      this.post.contact_a_afficher = contact ? contact.fullname : ''
      this.post.email_a_afficher = contact ? contact.email : ''
      this.post.telephone_a_afficher = contact ? contact.phone : ''
      this.post.telephone_mobile_a_afficher = contact ? contact.mobile : ''
    }
  },
  computed: {
    ...mapGetters(['isSubUser']),
    valeur () {
      const val = this.value
      this.value = ''
      return val
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  watch: {
    post () {
      if (this.post.contact_a_afficher && !this.hasAnnonce) {
        this.hasAnnonce = true
        this.controleContactSelectionne()
      }
    }
  }
}
</script>

<style scoped>

</style>
